import { StudentService } from 'src/app/core/services/student.service';
import { Enrollment } from './../../core/models/enrollment';
import { Component, OnInit } from '@angular/core';
import { Student } from 'src/app/core/models/student';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { Course } from '../../core/models/course';
import { EnrollmentService } from 'src/app/core/services/enrollment.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})
export class WishlistComponent extends BaseComponent implements OnInit {

  userFullName: string;
  studentId: number;

  tokenValid: boolean;
  p: number = 1;
  isTeacher: string;

  favouriteCourses: Enrollment[];
  courses: Course[];
  student = {} as Student

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private enrollmentService: EnrollmentService,
    private studentService: StudentService
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');

    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.enrollmentService.getStudentFav(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.favouriteCourses = data.result.returnData;
        this.courses = this.favouriteCourses.map(item => item.courses);
        // console.log(this.courses)
      }
    )

    this.studentService.get(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.student = data.result.returnData;
      }
    )
  }

  viewStudProfile(id) {
    this.router.navigate(['/student-profile/edit', this.studentId])
  }

  viewStudCourses(id) {
    this.router.navigate(['/student-courses/edit', this.studentId]);
  }

  viewStudSettings(id) {
    this.router.navigate(['/student-settings/edit', this.studentId]);
  }

  viewWishlist(id) {
    this.router.navigate(['/wishlist/edit', this.studentId]);
  }
  
  viewCourseDetails(id) {
    this.router.navigate(['/course-details/edit', id]);
  }

}
